// extracted by mini-css-extract-plugin
module.exports = {"item":"Style_item__2ogrA","title":"Style_title__8IgxJ","detail":"Style_detail__3a1m7","options":"Style_options__19mIS","duplicating":"Style_duplicating__3LwBR"};